import { FC } from 'react';

import { Tooltip } from 'antd';

import { InterviewSchedulerView } from 'constants/enums';

import { ReactComponent as PrevIcon } from 'assets/icons/calendar-arrow-left.svg';
import { ReactComponent as NextIcon } from 'assets/icons/calendar-arrow-right.svg';

import { useTranslation } from 'react-i18next';
import { NavigationAction } from '../../config/calendarConfig';
import styles from './NavigationControls.module.scss';

interface NavigationControlsProps {
  date: string;
  view: string;
  onNavigate: (action: NavigationAction) => void;
}

const NavigationControls: FC<NavigationControlsProps> = ({
  date,
  view,
  onNavigate
}) => {
  const { t } = useTranslation()

  const prevLabel =
    view === InterviewSchedulerView.Month ? t('common.prevMonth') : t('common.prevWeek');
  const todayLabel =
    view === InterviewSchedulerView.Month ? t('common.currMonth') : t('common.currWeek');
  const nextLabel =
    view === InterviewSchedulerView.Month ? t('common.nextMonth') : t('common.nextWeek');

  return (
    <div className={styles.navigationContainer}>
      <Tooltip title={prevLabel}>
        <span
          className={styles.buttonPrev}
          onClick={() => onNavigate(NavigationAction.Prev)}
        >
          <PrevIcon />
        </span>
      </Tooltip>
      <Tooltip title={todayLabel}>
        <span
          className={styles.labelCurrentDate}
          onClick={() => onNavigate(NavigationAction.Today)}
        >
          {date}
        </span>
      </Tooltip>
      <Tooltip title={nextLabel}>
        <span
          className={styles.buttonNext}
          onClick={() => onNavigate(NavigationAction.Next)}
        >
          <NextIcon />
        </span>
      </Tooltip>
    </div>
  );
};

export default NavigationControls;
